import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


   export const getData = createAsyncThunk('knownLocation/getData', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/GetTableSummary', params, {mode:'cors'})
      return {
         params,
         data: response.data.data,
         allData: response.data.allData,
         totalPages: response.data.total
      }
   })

   export const getKnownLocation = createAsyncThunk('knownLocation/getKnownLocation', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/GetTableSummary', params, {mode:'cors'})
      return {
         params,
         data: response.data.data, 
         allData: response.data.allData,
         totalPages: response.data.total
      }
   })
   
   export const addKnownLocation = createAsyncThunk('knownLocation/addKnownLocation', async (KnownLocation) => {
       
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/Create', KnownLocation, {mode:'cors'})
       
      return response
   })

   export const editKnownLocation  = createAsyncThunk('knownLocation/editKnownLocation', async (KnownLocation) => {
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/Update', KnownLocation, {mode:'cors'})
      return response
   })
   
   export const deleteKnownLocation = createAsyncThunk('knownLocation/deleteKnownLocation', async (id) => {
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/Delete', id, {mode:'cors'})
      return response
   })

   export const getKnownLocationEditData = createAsyncThunk('knownLocation/getKnownLocationEditData', async (params) => {
      const response = await axios.post(' https://api.zasway.com:8443/KnownLocation/GetTableSummary', params, {mode:'cors'})
      return {
         data: response.data.data
      }
   })

   export const resetKnownLocationEditData = createAsyncThunk('knownLocation/resetKnownLocationEditData', async () => {
      return {
         data: []
      }
   })

   export const getLocationTypeList = createAsyncThunk('knownLocation/getLocationTypeList', async () => {
      const response = await axios.post(' https://api.zasway.com:8443/Common/GetLocationTypeList')
      return response.data
   })
  
   export const KnownLocationSlice = createSlice({
         name: 'knownLocation',
         initialState: {
            data: [],
            allData: [],
            total: 1,
            params: {},
            KnownLocationData: [],
            knownLocationEditData: [],
            LocationEditData: []
         },
         reducers: {},
         extraReducers: builder => {
         builder

         .addCase(getData.fulfilled, (state, action) => {
            state.data = action.payload.data
            // state.allData = action.payload.allData
            state.total = action.payload.totalPages
            state.params = action.payload.params
         })
    
         .addCase(getKnownLocation.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            // state.allData = action.payload.allData
            state.total = action.payload.totalPages
         })
    
         .addCase(getKnownLocationEditData.fulfilled, (state, action) => {
            state.knownLocationEditData = action.payload.data
         })
    
         .addCase(resetKnownLocationEditData.fulfilled, (state, action) => {
            state.knownLocationEditData = action.payload.data
         })
      }
   })

export default KnownLocationSlice.reducer